<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form @submit.prevent="submit()">
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">{{ renew ? 'Renovar subgrupo' : 'Editar subgrupo'}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :error-messages="nameErrors"
                    v-model="$v.subgroupForm.name.$model"
                    label="Nombre"
                    :disabled="renew"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  {{ renew ? 'Selecciona el nuevo periodo de vigencia del subgrupo' : 'Editar periodo de vigencia'}}
                  <span class="error" v-if="startError" style="margin-top: 10px">{{ startError }}</span>
                  <span class="error" v-if="endError" style="margin-top: 10px">{{ endError }}</span>
                  <v-layout style="margin-top: 10px">
                    <v-flex md6>
                      <DatePicker
                        titleDate="Fecha inicial"
                        v-model="subgroupForm.startDate"
                        @input="startValidate"
                      />
                    </v-flex>
                    <v-flex md6>
                      <DatePicker
                        titleDate="Fecha de término"
                        v-model="subgroupForm.finalDate"
                        @input="endValidate"
                      />
                    </v-flex>
                  </v-layout>
                  
                </v-flex>
                <v-flex xs12 v-if="subgroup != null">
                  <v-layout wrap>
                    <v-flex xs12 id="days-subgroups">
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.monday"
                        label="Lunes"
                        hide-details
                      />
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.tuesday"
                        label="Martes"
                        hide-details
                      />
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.wednesday"
                        label="Miércoles"
                        hide-details
                      />
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.thursday"
                        label="Jueves"
                        hide-details
                      />
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.friday"
                        label="Viernes"
                        hide-details
                      />
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.saturday"
                        label="Sábado"
                        hide-details
                      />
                      <v-checkbox
                        :disabled="renew"
                        color="primary"
                        v-model="subgroup.sunday"
                        label="Domingo"
                        hide-details
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn :disabled="working.wUpdate" flat @click="cancel">Cancelar</v-btn>
            <v-btn :disabled="working.wUpdate" color="primary darken-1" type="submit" flat>Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."/>
    <success v-model="toast.success" text="Edición Exitosa"/>
    <error v-model="toast.failed" :text="toast.eMessage"/>
    <alert 
      v-model="toast.alert" 
      title="Aviso" 
      :description="toast.description"
    />
  </div>
</template>

<script>
import DatePicker from "../../Tools/DatePicker";
import { required } from "vuelidate/lib/validators";
import loading from "../../Dialogs/Loading.vue";
import success from "../../Dialogs/Success.vue";
import error from "../../Dialogs/Error.vue";
import alert from "../../Dialogs/Alert";

export default {
  props: ["value", "subgroup", "renew"],
  components: {
    loading,
    success,
    error,
    alert,
    DatePicker
  },
  validations: {
    subgroupForm: {
      name: { required }
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.subgroup !== null) {
          this.subgroupForm.id = this.subgroup.id;
          this.subgroupForm.name = this.subgroup.name;
          this.subgroupForm.start = this.subgroup.start;
          this.subgroupForm.end = this.subgroup.end;
          this.subgroupForm.startDate = this.subgroup.startDate;
          this.subgroupForm.finalDate = this.subgroup.finalDate;
          this.subgroupForm.idGradeGroup = this.subgroup.idGradeGroup;
        }
      }
    },
  },
  mounted() {},
  data: () => ({
    modalI: false,
    subgroupForm: {
      id: "",
      name: "",
      idGradeGroup: "",
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10),
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false
    },
    working: {
      wUpdate: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: "",
      alert: false,
      description: ""
    },
    startError: "",
    endError: ""
  }),
  methods: {
    async submit(event = null) {
      this.$v.subgroupForm.$touch();
      
      this.startValidate();
      this.endValidate();

      if (!this.$v.subgroupForm.$invalid && this.daysValids() && (!this.startError && !this.endError)) {
        this.working.wUpdate = true;
        this.subgroupForm.monday = this.subgroup.monday
        this.subgroupForm.tuesday = this.subgroup.tuesday
        this.subgroupForm.wednesday = this.subgroup.wednesday
        this.subgroupForm.thursday = this.subgroup.thursday
        this.subgroupForm.friday = this.subgroup.friday
        this.subgroupForm.saturday = this.subgroup.saturday
        this.subgroupForm.sunday = this.subgroup.sunday;
        this.subgroupForm.start = `${this.subgroupForm.startDate.getFullYear()}-${this.subgroupForm.startDate.getMonth() < 9 ? '0' : ''}${this.subgroupForm.startDate.getMonth()+1}-${this.subgroupForm.startDate.getDate()}`;
        this.subgroupForm.end = `${this.subgroupForm.finalDate.getFullYear()}-${this.subgroupForm.finalDate.getMonth() < 9 ? '0' : ''}${this.subgroupForm.finalDate.getMonth()+1}-${this.subgroupForm.finalDate.getDate()}`;
        try {
          let response;
          if (this.renew) {
            response = await this.$store.dispatch("subgroups/renew", {id: this.subgroupForm.id, start: this.subgroupForm.start, end: this.subgroupForm.end});
          } else {
            response = await this.$store.dispatch("subgroups/update", this.subgroupForm);
          }

          this.working.wUpdate = false;
          this.$v.subgroupForm.$reset();
          this.$emit("created", true, response.data);
          this.close();
        } catch (error) {
          this.working.wUpdate = false;
          this.$emit("created", false, null);
        }
        
      }
    },
    cancel() {
      this.$emit("cancelled");
      this.close();
    },
    close() {
      this.$v.subgroupForm.$reset();
      this.subgroupForm = {
        name: "",
        idGradeGroup: "",
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        sunday: false
      };
    },
    daysValids(){
        this.toast.description = "";
        if (!this.subgroup.monday && !this.subgroup.tuesday && !this.subgroup.wednesday && !this.subgroup.thursday && 
                !this.subgroup.friday && !this.subgroup.saturday && !this.subgroup.sunday) {
            this.toast.description = "Debe seleccionar al menos un día";
            this.toast.alert = true;
            return false;
        }
        return true;
    },
    startValidate() {
      if (this.subgroupForm.startDate) {
        const todayTime = new Date();
        todayTime.setHours(0, 0, 0, 0);

        this.subgroupForm.startDate.setHours(0, 0, 0, 0);
        const startTime = this.subgroupForm.startDate.getTime();

        if (isNaN(startTime)){ //invalid
          this.startError = "Ingresa una fecha incial válida.";
        }else if (startTime < todayTime.getTime()){ 
          this.startError = "La fecha inicial debe ser posterior al día de hoy.";
        } else {
          this.startError = "";
        }
      }else 
        this.startError = "Ingresa una fecha inicial.";
    },
    endValidate() {
      if (this.subgroupForm.finalDate) {

        this.subgroupForm.finalDate.setHours(0, 0, 0, 0);

        if (isNaN(this.subgroupForm.finalDate.getTime())){ //invalid
          this.endError = "Ingresa una fecha final válida.";
        }else if (this.subgroupForm.startDate && this.subgroupForm.startDate.getTime() >= this.subgroupForm.finalDate.getTime()){ 
          this.endError = "La fecha de término debe ser posterior a la fecha inicial.";
        } else {
          this.endError = "";
        }
      } else 
          this.endError = "Ingresa una fecha final.";
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.subgroupForm.name.$dirty) return errors;
      !this.$v.subgroupForm.name.required && errors.push("Título obligatorio");
      return errors;
    }
  },
};
</script>

<style scoped>
.error {
  background-color: transparent !important;
  color: #ff5252;
  display: block;
}
#days-subgroups .v-input--selection-controls {
    margin-top: 0 !important;
}
</style>
